import React from 'react';
import { Text } from '../custom-components';

const DpbDigitalOfficeSync = () => {
  return (
    <div className="configurePage">
      <div className="template-header-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
        <div className="template-title-section">
          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Text appearance="heading-s" color="primary-grey-100">DPB Digital Office Sync</Text>
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: '24px', backgroundColor: 'white', borderRadius: '8px', marginTop: '24px' }}>
        <Text>Upcoming</Text>
      </div>
    </div>
  );
};

export default DpbDigitalOfficeSync;
